import * as React from "react";
const SvgFiRrTextBoxEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-text-box-edit_svg__a)">
      <path
        fill="#062147"
        d="M13 20a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V8c0-2.757 2.243-5 5-5h7a1 1 0 1 1 0 2H5C3.346 5 2 6.346 2 8v8c0 1.654 1.346 3 3 3h7a1 1 0 0 1 1 1m-5-3a1 1 0 0 0 1-1V9h2a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2h2v7a1 1 0 0 0 1 1m10 5c-.551 0-1-.448-1-1V3c0-.552.449-1 1-1a1 1 0 0 0 0-2c-.768 0-1.469.29-2 .766A3 3 0 0 0 14 0a1 1 0 1 0 0 2 1 1 0 0 1 1 1v18c0 .552-.449 1-1 1a1 1 0 0 0 0 2c.768 0 1.469-.29 2-.766A3 3 0 0 0 18 24a1 1 0 1 0 0-2m2.25-18.843a1 1 0 1 0-.499 1.938A3 3 0 0 1 22.001 8v8c0 1.37-.925 2.564-2.25 2.905a1.001 1.001 0 0 0 .499 1.938A5 5 0 0 0 24 16V8a5 5 0 0 0-3.75-4.843"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-text-box-edit_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTextBoxEdit;
